import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-expanded", "onClick"]
const _hoisted_2 = { class: "flex items-center overflow-hidden rounded-full border-2 border-primary fill-current text-primary" }

import BaseDropdown from '@/components/base/BaseDropdown.vue'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ProfileSummary'
},
  __name: 'ProfileSummary',
  setup(__props) {



const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(BaseDropdown, { id: "user-menu" }, {
    button: _withCtx(({ toggle, open }) => [
      _createElementVNode("button", {
        id: "user-menu",
        type: "button",
        class: "flex max-w-xs items-center justify-center rounded-full fill-current text-sm focus:shadow-outline focus:outline-hidden",
        "aria-label": "User menu",
        "aria-haspopup": "true",
        "aria-expanded": `${open}`,
        onClick: toggle
      }, [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_VIcon, {
            icon: "$account-outline",
            class: "rounded-full bg-white text-primary",
            size: "1.75rem"
          })
        ])
      ], 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_RouterLink, {
        to: { name: 'settings' },
        class: "block w-full px-4 py-2 text-left text-lg transition duration-150 ease-in-out hover:bg-secondary-100 md:text-sm",
        role: "menuitem"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('general.my_account')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        type: "button",
        class: "block w-full px-4 py-2 text-left text-lg transition duration-150 ease-in-out hover:bg-secondary-100 md:text-sm",
        role: "menuitem",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.dispatch('auth/logout')))
      }, _toDisplayString(_unref(t)('general.sign_out')), 1)
    ]),
    _: 1
  }))
}
}

})